<div>
  <h6 class="content-header">Profile activity</h6>
</div>
<div class="card" [ngClass]="!(profileState | async).loader['audit']['mediaAnalyze'] ? 'background-loader' : ''">
  <div class="card-body">
    <div class="spinner" *ngIf="!(profileState | async).loader['audit']['mediaAnalyze']"></div>
    <div class="row">
      <div class="col-sm-6 mb-3 mb-sm-0">
        <div class="btn-group">
          <button class="btn" [ngClass]="key === 'day' ? 'btn-light' : 'btn-default'" (click)="setKey('day')">Day</button>
          <button class="btn" [ngClass]="key === 'week' ? 'btn-light' : 'btn-default'" (click)="setKey('week')">Week</button>
          <button class="btn" [ngClass]="key === 'month' ? 'btn-light' : 'btn-default'" (click)="setKey('month')">Month</button>
        </div>
      </div>
      <div class="col-sm-6 text-right text-sm-left">
        <div class="btn-group">
          <button class="btn btn-default" [ngClass]="prefix === 'post' ? 'btn-light' : 'btn-default'" (click)="setMetric('post')">Posts</button>
          <button class="btn btn-default" [ngClass]="prefix === 'like' ? 'btn-light' : 'btn-default'" (click)="setMetric('like')">Likes</button>
          <button class="btn btn-default" [ngClass]="prefix === 'comment' ? 'btn-light' : 'btn-default'" (click)="setMetric('comment')">Comments</button>
          <button class="btn btn-default" [ngClass]="prefix === 'reach' ? 'btn-light' : 'btn-default'" (click)="setMetric('reach')">Reach</button>
        </div>
      </div>
    </div>
    <div
      class="text-center box-md mt-4"
      *ngIf="charts !== undefined"
    >
      <div [chart]="charts[0]"></div>
    </div>
    <div class="report-results my-2" *ngIf="(profileState | async).mediaAnalyze !== null">
      <div class="b-left mb-3 mb-sm-0">
        <h2>{{(profileState | async).mediaAnalyze[this.prefix + '_day_avg'].value | number:'1.2'}}</h2>
        <p class="sub-text">Avg. no of {{this.prefix}} per day</p>
      </div>
      <div class="b-left  mb-3 mb-sm-0">
        <h2>{{(profileState | async).mediaAnalyze[this.prefix + '_week_avg'].value | number:'1.2'}}</h2>
        <p class="sub-text">Avg. no of {{this.prefix}} per week</p>
      </div>
      <div class="b-left">
        <h2>{{(profileState | async).mediaAnalyze[this.prefix + '_month_avg'].value | number:'1.2'}}</h2>
        <p class="sub-text">Avg. no of {{this.prefix}} per month</p>
      </div>
    </div>
  </div>
</div>
